import { usePlayerContext } from '../PlayerContext';
import { usePluginSlot } from '../hooks/usePluginSlot';

interface Props {
  slot: string;
}

export function PluginSlot({ slot }: Props) {
  const { uiRegistry } = usePlayerContext();
  const components = usePluginSlot(uiRegistry, slot);

  return (
    <>
      {components.map((Comp, i) => (
        <Comp key={(Comp as { displayName?: string }).displayName ?? i} />
      ))}
    </>
  );
}
